import { RootState } from '~/store';

export const authorBlogSelector = (state: RootState) => state.authorBlog;
